export default __webpack_public_path__ + "static/media/Moderat-Extended-Thin.0521f091.ttf";